import gql from 'graphql-tag';

export const createNotification = gql`
	mutation createNotification($gameId: ID!, $notification: NotificationInput!) {
		createNotification(gameId: $gameId, notification: $notification) {
			id
		}
	}
`;
